export const backendURL = process.env.REACT_APP_BASE_URL;

// Set REACT_APP_ENABLE_MARKETPLACE=false (e.g. on staging) to hide the Marketplace module.
export const isMarketplaceEnabled = process.env.REACT_APP_ENABLE_MARKETPLACE !== "false";
